export default __webpack_public_path__ + "images/BR.abd29f5.png";